module.exports = __webpack_public_path__ + "static/media/Avatar2.5a48ffb7.png";